/* eslint-disable no-plusplus */
const isBrowser = typeof window !== "undefined";

export const stringifyOptions = (options) => {
  const obj = Object.keys(options).reduce((acc, key) => {
    if (key === "days") {
      return acc;
    }
    if (options[key] === false) {
      return acc;
    }
    if (options[key] === true) {
      return `${acc}; ${key}`;
    }
    return `${acc}; ${key}=${options[key]}`;
  }, "");

  return obj;
};

export const setCookie = (name, value, options = {}) => {
  if (!isBrowser) return;

  const optionsWithDefaults = {
    path: "/", // Set the default path for the cookie
    ...options
  };

  // No need to set an expiration date for session cookies
  let expires = "";

  if (optionsWithDefaults.days) {
    expires = `; expires=${new Date(
      Date.now() + optionsWithDefaults.days * 864e5
    ).toUTCString()}`;
  }

  document.cookie = `${name}=${encodeURIComponent(
    value
  )}${expires}${stringifyOptions(optionsWithDefaults)}`;
};

export const getCookie = (name, initialValue = "") => {
  return (
    (isBrowser &&
      document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
      }, "")) ||
    initialValue
  );
};

export const deleteCookies = () => {
  const expires = new Date(0).toUTCString();
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [name] = cookies[i].split("=");
    document.cookie = `${encodeURIComponent(name)}=;expires=${expires};path=/`;
  }
};
